import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

var router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () =>
        import(/* webpackChunkName:"Home" */ "../views/Home.vue"),
      meta: {
        title: "",
        keepAlive: true
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
